<template>
	<div ref="popupView" :style="{ left: leftPos + left + 'px', top: topPos + top + 'px' }" class="popup-view">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
				leftPos: 0,
				topPos: 0,

				box: {
					left: 0,
					top: 0,
					width: 0,
					height: 0
				},

				width: 0,
				height: 0,
				winWidth: 0,
				winHeight: 0
			};
		},
		props: {
			anchor: {
				//type: Any,//[MouseEvent, TouchEvent, HTMLElement],
				required: true
			},
			align: {
				type: String,
				default: 'left'
			},
			left: {
				type: Number,
				default: 0
			},
			top: {
				type: Number,
				default: 0
			}
		},
		methods: {
			getLeft() {
				if (this.anchor instanceof MouseEvent || this.anchor instanceof TouchEvent) {
					if (this.width + this.anchor.x > this.winWidth || this.align == 'right') {
						return this.anchor.x - this.width;
					} else {
						return this.anchor.x;
					}
				} else {
					//var box = this.anchor.getBoundingClientRect();

					if (this.box.left + this.width > this.winWidth || this.align == 'right') {
						return this.box.left - (this.width - this.box.width);
					} else {
						return this.box.left;
					}
				}
			},
			getTop() {
				console.log(this.anchor);

				if (this.anchor instanceof MouseEvent || this.anchor instanceof TouchEvent) {
					if (this.height + this.anchor.y > this.winHeight) {
						return this.anchor.y - this.height;
					} else {
						return this.anchor.y;
					}
				} else {
					//var box = this.anchor.getBoundingClientRect();

					//console.log(box, this.height, this.winHeight);

					if (this.box.top + this.box.height + this.height > this.winHeight) {
						console.log('popup, overflow y', this.height, this.height);
						return this.box.top - this.height - 5;
					} else {
						console.log('popup, y', this.height, this.height);
						return this.box.top + this.box.height + 5;
					}
				}
			},
			update() {
				var self = this;

				this.$nextTick(function () {
					// Code that will run only after the
					// entire view has been re-rendered, including child comps
					if (!(this.anchor instanceof MouseEvent || this.anchor instanceof TouchEvent)) {
						self.box 		= self.anchor.getBoundingClientRect();
					}

					self.leftPos 	= self.getLeft();
					self.topPos 	= self.getTop();

					console.log('tick!');
				});
			}
		},
		updated() {
			this.update();
		},
		mounted() {
			console.log('mounted!');

			this.width 		= this.$refs.popupView.clientWidth;
			this.height 	= this.$refs.popupView.clientHeight;
			this.winWidth	= window.innerWidth;
			this.winHeight	= window.innerHeight;

			this.update();
		}
	}
</script>

<style lang="scss" scoped>
	.popup-view {
		position: absolute;
		pointer-events: auto;
		background-color: white;
		border-radius: 3px;

		-webkit-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
		-moz-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
		box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
	}
</style>